<div class="card-body widget-body pb-0 pt-2 mb-4">
  <div class="row">
    <div class="offset-lg-10 col-lg-2 text-end">
      <button type="button" class="btn btn-primary btn-sm"  
        [disabled]="this.global.viewTabs"  *ngIf="fp.startofcarecreate"
        (click)="AddStartofcare('new')">
        Add Start of Care
      </button>
    </div>
  </div>
 <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update SOCTotalColumns constant in client.startofcarelist.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'SOCGrid' maps to localStorage key 'gridSOCGrid'
                                                                          -->
  <ejs-grid #grid  id="SOCGrid" [dataSource]='data|async' [allowResizing]='true' [allowSorting]='true' allowPaging='true'
   [allowReordering]="true" 
  [enablePersistence]="true"
    [allowFiltering]='true' [pageSettings]='initialPage' (dataStateChange)='dataStateChange($event)'
    [filterSettings]='filterOptions' (resizeStop)="onResize($event)" (actionBegin)="onActionComplete($event)">
    <e-columns>
      <e-column minWidth=100 uid="action" headerText="Actions" textAlign='center'>
        <ng-template #template let-data>
          <button class="btn btn-edit-table btn-sm me-2" 
            (click)="Datatoedit(data);AddStartofcare('edit');"  
            [disabled]="this.global.viewTabs"  *ngIf="fp.startofcareupdate" >
            <i class="fa fa-edit"></i>
          </button>
          <button class="btn btn-delete-table btn-sm" 
            (click)="Datatoedit(data);AddStartofcare('delete');"  
            [disabled]="this.global.viewTabs"  *ngIf="fp.startofcaredelete" >
            <i class="fa fa-trash fa-lg"></i>
          </button>
        </ng-template>
      </e-column>
      <e-column minWidth=100 field="startDate" headerText="Start Of Care" type='date' [format]='formatOptions'>
      </e-column>
      <e-column minWidth=100 field="companyName" headerText="Company">
        <ng-template #filterTemplate let-data>
          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
        </ng-template>
      </e-column>
      <e-column minWidth=100 field="dischargeStatus" headerText="Discharge" [allowFiltering]='false'>
        <ng-template #filterTemplate let-data>
          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
        </ng-template>
      </e-column>
      <e-column minWidth=100 field="dischargeDate" headerText="Discharge Date" type='date' [format]='formatOptions'
        [allowFiltering]='false'></e-column>
      <e-column minWidth=100 field="dischargeCode" headerText="Discharge Status Code" [allowFiltering]='false'>
        <ng-template #filterTemplate let-data>
          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
        </ng-template>
      </e-column>
    </e-columns>
  </ejs-grid>
   <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update SOCTotalColumns constant in client.startofcarelist.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'SOCGrid' maps to localStorage key 'gridSOCGrid'
                                                                          -->
</div>
